import React, { useState} from 'react'
import format from "date-fns/format";
import getDay from "date-fns/getDay";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const locales = {
    'en-IN': require('date-fns/locale/en-IN')
};

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
})

const events = [
    {
        title: "Live Session",
        allDay: true,
        start: new Date(2023, 5, 24),
        end: new Date(2023, 5, 25),
    },
    {
        title: "Assignment",
        start: new Date(2023, 6, 7),
        end: new Date(2023, 6, 10),
    },
    {
        title: "Live Session",
        start: new Date(2023, 5, 20),
        end: new Date(2023, 5, 22),
    },
];


function CalendarClassRoom() {
  return (
    <div>
        <Calendar 
        localizer={localizer} 
        events={events} 
        startAccessor='start' 
        endAccessor='end' 
        style={{height: 500, margin: '50px'}}
        />
    </div>
  )
}

export default CalendarClassRoom